import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Loader = styled.div`
  padding: 20px;
  text-align: center;
  margin-top: 60px;
`;

interface Props {
  isLoading: boolean;
  isError: boolean;
  hasData: boolean;
}

const ListWrap: FC<PropsWithChildren<Props>> = ({
  isLoading,
  isError,
  hasData,
  children,
}) => {
  if (isLoading) {
    return (
      <Loader>
        <Text $type="heading2">Loading data...</Text>
      </Loader>
    );
  }
  if (isError) {
    return (
      <Loader>
        <Text $type="heading2">An error occurred!</Text>
      </Loader>
    );
  }
  if (!hasData) {
    return (
      <Loader>
        <Text $type="heading2">No Data</Text>
      </Loader>
    );
  }
  return <>{children}</>;
};

export default ListWrap;
